module.exports = __webpack_public_path__ + "img/e_2_20_g.d9f30d71.png";